// src/utils/gmaps.js

// Your personal API key.
// Get it here: https://console.cloud.google.com/google/maps-apis
const CALLBACK_NAME = 'gmapsCallback'

let initialized = !!window.google
let resolveInitPromise
let rejectInitPromise

let geocoder

// This promise handles the initialization
// status of the google maps script.
const initPromise = new Promise((resolve, reject) => {
  resolveInitPromise = resolve
  rejectInitPromise = reject
})
const init = (apiKey) => {
  // If Google Maps already is initialized
  // the `initPromise` should get resolved
  // eventually.
  if (initialized) return initPromise

  initialized = true
  // The callback function is called by
  // the Google Maps script if it is
  // successfully loaded.
  window[CALLBACK_NAME] = () => resolveInitPromise(window.google)

  // We inject a new script tag into
  // the `<head>` of our HTML to load
  // the Google Maps script.
  const script = document.createElement('script')
  script.async = true
  script.defer = true
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=${CALLBACK_NAME}&libraries=places&loading=async`
  script.onerror = rejectInitPromise
  document.querySelector('head').appendChild(script)
  return initPromise
}

const geocode = (query) => {
  return new Promise((resolve, reject) => {
    if (!geocoder) { geocoder = new window.google.maps.Geocoder() }
    geocoder.geocode(query, (results, status) => {
      if (status !== "OK" || !results) {
        reject(status)
      } else {
        resolve(results[0])
      }
    })
  })
}

const getMap = (element) => {
  return new window.google.maps.Map(element)
}

const getAutoComplete = (element, options) => {
  return new window.google.maps.places.Autocomplete(element, options)
}

const getLatLng = (latitude, longitude) => {
  return new window.google.maps.LatLng(latitude, longitude)
}

const getLatLngBounds = () => {
  return new window.google.maps.LatLngBounds()
}

const getMarker = (data) => {
  return new window.google.maps.Marker(data)
}

const getInfoWindow = (content) => {
  return new window.google.maps.InfoWindow({ content })
}

export default {
  init,
  geocode,
  getMap,
  getAutoComplete,
  getLatLng,
  getLatLngBounds,
  getMarker,
  getInfoWindow
}
